import { render, staticRenderFns } from "./affilaiteSettings.vue?vue&type=template&id=3003ce1a&"
import script from "./affilaiteSettings.vue?vue&type=script&lang=js&"
export * from "./affilaiteSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports